(function ($) {
    "use strict";

    function initDatepicker() {
        var defaultOptions = {
            changeMonth: true,
            changeYear: true,
            yearRange: "1900:c+100",
            maxDate: "-1"
        };

        $("[data-datepicker]").datepicker(defaultOptions);
    }

    $(function () {
        initDatepicker();
    });

    $("form").submit(function (form) {;
        var captcha = $(form.target).find("#Captcha");
        if (captcha.length > 0) {
            var captchaValue = $(form.target).find("#Captcha").val()
            if (!(captchaValue.length > 0)) {
                $(".captcha-notification").show();
                event.preventDefault();
                return false;
            }
            $(".captcha-notification").hide();
        }
    });
})(jQuery);

var recaptchaCallback = function () {
    $("#Captcha").val(grecaptcha.getResponse());
    $(".captcha-notification").hide();
};